import { render, staticRenderFns } from "./conDetail.vue?vue&type=template&id=23a7391b&scoped=true"
import script from "./conDetail.vue?vue&type=script&lang=js"
export * from "./conDetail.vue?vue&type=script&lang=js"
import style0 from "./conDetail.vue?vue&type=style&index=0&id=23a7391b&prod&lang=less&scoped=true"
import style1 from "./conDetail.vue?vue&type=style&index=1&id=23a7391b&prod&lang=less"
import style2 from "./conDetail.vue?vue&type=style&index=2&id=23a7391b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7391b",
  null
  
)

export default component.exports